import clsx from "clsx";
import { FC, MouseEvent } from "react";

interface TextareaProps {
  id: string;
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  useInputTheme?: boolean;
  onClick?: (e: MouseEvent<HTMLTextAreaElement>) => void;
}

const Textarea: FC<TextareaProps> = ({
  id,
  value,
  onChange,
  placeholder,
  label,
  useInputTheme = false,
  onClick,
}) => {
  return (
    <div className={clsx("flex flex-col")}>
      {label && (
        <label
          htmlFor={id}
          className="mb-1.5 sm:mb-2.5 text-base sm:text-lg lg:text-[19px] lg:leading-[29px] text-black font-normal"
        >
          {label}
        </label>
      )}
      <textarea
        id={id}
        rows={4}
        value={value}
        placeholder={placeholder}
        onChange={({ target }) => onChange(target.value)}
        onClick={onClick}
        className={clsx(
          "textarea text-[19px] leading-[29px]",
          useInputTheme &&
            "!text-base !sm:text-lg !border-[3px] !border-soft focus:!border-medium-green focus:outline-none"
        )}
      />
    </div>
  );
};

export default Textarea;
